import { PropTypes } from 'prop-types'

/**
 * @typedef {Object} Application
 * @property {string} [applicationId] - ID of the application.
 * @property {string} [name] - The unique name of the application. Use stringCode to resolve a proper translation for the
 *   display name.
 * @property {string} [stringCode] - The string code to be used to resolve a translated display name.
 * @property {number} [sortOrder] - Hint for displaying applications of a group in a defined order in the UI. The order
 *   is defined separately for each group.
 */
export const applicationPropType = PropTypes.shape({
    applicationId: PropTypes.string,
    name: PropTypes.string,
    sortOrder: PropTypes.number,
    stringCode: PropTypes.string
})
